import * as firebase from "firebase";

const config = {
    apiKey: "AIzaSyConLiRER4G1e58dnVB4Bvb7Gh8V6afrUk",
    authDomain: "fuorisalone-wb.firebaseapp.com",
    databaseURL: "https://fuorisalone-wb.firebaseio.com",
    projectId: "fuorisalone-wb",
    storageBucket: "",
    messagingSenderId: "233964561659"
};

/*const config = {
    apiKey: "AIzaSyA_sRFstPKKqyOGazujpYrio1mMEIxfX_c",
    authDomain: "fuorisalone-wb-testing.firebaseapp.com",
    databaseURL: "https://fuorisalone-wb-testing.firebaseio.com",
    projectId: "fuorisalone-wb-testing",
    storageBucket: "",
    messagingSenderId: "427766308700"
};*/

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();



// WEBPACK FOOTER //
// ./src/firebase_config.js